import React from 'react';

import * as Styled from './styles';

export interface ITextarea {
  value?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  'data-testid'?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Textarea = ({ value, name, onChange, label, placeholder, className, disabled = false, ...other }: ITextarea) => {
  const dataTestId = other['data-testid'];

  return (
    <Styled.TextareaWrap>
      {label && <Styled.TextareaLabel htmlFor={name}>{label}</Styled.TextareaLabel>}
      <Styled.Textarea
        className={className}
        data-testid={dataTestId}
        disabled={disabled}
        value={value}
        onChange={onChange}
        name={name}
        placeholder={placeholder || ''}
      />
    </Styled.TextareaWrap>
  );
};
